import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import { AddLearnerDto } from "src/app/_models/AddLearnerDto";
import { Userprofile } from "src/app/_models/Userprofile";
import { CreateLearnerActionTypes } from "src/app/constants/StoreConstants";

export const SetLearner = createAction(
  CreateLearnerActionTypes.SetLearner,
  props<{dto: AddLearnerDto}>()
);

export const CreateLearner = createAction(
  CreateLearnerActionTypes.CreateLearner
);

export const CreateLearnerSuccess = createAction(
  CreateLearnerActionTypes.CreateLearnerSuccess,
  props<{result: Userprofile}>()
);

export const CreateLearnerError = createAction(
  CreateLearnerActionTypes.CreateLearnerError,
  props<{error: HttpErrorResponse}>()
);

export const ResetCreateLearnerState = createAction(
  CreateLearnerActionTypes.ResetCreateLearnerState
);